import {useIsLoggedIn} from "@/hooks/useUserHooks";
import clsxm from "@/lib/clsxm";
import RegistrationInputField from "@/pages/registerCompany/RegistrationInputField";
import RegistrationEmailField from "@/pages/registerCompany/steps/credentials/RegistrationEmailField";
import RegistrationPasswordField from "@/pages/registerCompany/steps/credentials/RegistrationPasswordField";
import {type FC} from "react";
import {useTranslation} from "react-i18next";

const CredentialsStep: FC<{showCompanyName?: boolean; className?: string}> = ({showCompanyName = true, className}) => {
  const {t} = useTranslation();
  const isLoggedIn = useIsLoggedIn();

  return (
    <div className={clsxm("flex w-full flex-col gap-5", className)}>
      <div className="flex flex-col items-stretch gap-1">
        <label htmlFor="firstName" className="text-neutral-grey-dark text-sm font-medium">
          {t("name")}
        </label>
        <div className="flex w-full justify-stretch gap-2">
          <RegistrationInputField storeKey="firstName" placeholder={t("First name")} />
          <RegistrationInputField storeKey="lastName" placeholder={t("Surname")} />
        </div>
      </div>
      {showCompanyName && (
        <RegistrationInputField
          storeKey="companyName"
          label={t("companyName")}
          placeholder={t("companyNamePlaceholder")}
        />
      )}
      <RegistrationEmailField />
      {!isLoggedIn && <RegistrationPasswordField />}
    </div>
  );
};

export default CredentialsStep;
